import { render, staticRenderFns } from "./c10ImportContacts.vue?vue&type=template&id=71849276"
import script from "./c10ImportContacts.vue?vue&type=script&lang=js"
export * from "./c10ImportContacts.vue?vue&type=script&lang=js"
import style0 from "./c10ImportContacts.vue?vue&type=style&index=0&id=71849276&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports